import { cva } from 'class-variance-authority'

export const LoadingOverlayStyles = cva([], { variants: {} })
